import { Injectable } from '@angular/core';
import { UserModel } from 'src/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserStorage {
  private _user: UserModel;

  constructor() {}

  set user(user: UserModel) {
    this._user = user;
  }

  get hashcode() {
    return this._user.hash;
  }
}
